import React from "react";

export default function Status({hoverModalDisplay}) {
  return (<div id="fedramp-statusBox" className={`fedramp-statusBoxClass fedramp-hoverBox${hoverModalDisplay}`}>
    <strong>Status:</strong>
    <br/><br/>
    Authorization process status:
    <br/>
    <ul>
      <li>
        <strong>Ready:</strong>
        A Third Party Assessment Organization attests to a cloud service’s readiness for the authorization process.
      </li>
      <li>
        <strong>In Process:</strong> Working with the Joint Authorization Board or an Agency to attain a FedRAMP
        authorization.
      </li>
      <li>
        <strong>Authorization:</strong> FedRAMP authorization process completed.
      </li>
    </ul>
  </div>);
}